import { useEffect, useMemo, useState } from 'react'
import { Button } from 'baseui/button';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalButton,
} from 'baseui/modal';
import { FormControl } from "baseui/form-control";
import { Input } from "baseui/input";
import { IoAddOutline } from 'react-icons/io5'
import { getUserId } from '../../services/silentAuth';
import { Select } from 'baseui/select';
import { useHasRole } from '../../hooks/useHasRole';
import { AccessRoles } from '../../hooks/useHasRole/accessRoles';
import { useStyletron } from 'baseui';
import { FormattedMessage, useIntl } from 'react-intl';
import { CreateObjectInstanceCommand, useCreateObjectMutation } from '../../services/objects';
import { schema as schemaDashboardCollection } from './types'
import { useGetUsersResourceGroupsQuery } from '../../services/resourceGroups/userApi';
import { TCompany } from '../../automationObjects/Agents/Organizations/Company/types';

const NewButton = (props: { onDashboardCreated: () => void}) => {
    const [css, theme] = useStyletron();
    const intl = useIntl();
    const hasAccess = useHasRole(AccessRoles.Dashboard.Write);
    const [isOpen, setIsOpen] = useState(false);
    const [createDashboard, createDashboardResult] = useCreateObjectMutation();
    const [newName, setNewName] = useState("");
    // resource group 
    // get resource groups for this account
    const userId = getUserId();
    const { data: allowedResourceGroups, isSuccess } = useGetUsersResourceGroupsQuery(userId || '', { skip: !userId });
    const [resourceGroup, setResourceGroup] = useState<any>();
    const resourceGroupsSelect = useMemo(() => allowedResourceGroups?.map((item: TCompany, index: number) => { return { label: item.name, id: item.id } }),[allowedResourceGroups]);
    
    const onNewNameChange = (e: any) => setNewName(e.target.value);
    const onResourceGroupChanged = (e: any) => setResourceGroup(e.value[0]);

    const handleNewDashboardClick = () => {
        const cmd: CreateObjectInstanceCommand = {
            name: newName,
            resourceGroupId: resourceGroup.id,
            description: newName,
            schema: schemaDashboardCollection
        }
        createDashboard(cmd);
        setIsOpen(false);
    }

    useEffect(() => {
        if ( createDashboardResult.isSuccess)
            props.onDashboardCreated();
    },[createDashboardResult])

    return (
        <>
            <Button title={intl.formatMessage({ id: "Dashboard.AddNewButtonTitle", defaultMessage: "Add new Dashboard" })} className={css({ boxShadow: theme.lighting.shadow500 })} shape='circle' disabled={!hasAccess} key="new" onClick={() => setIsOpen(true)}><IoAddOutline /></Button>
            <Modal closeable onClose={() => setIsOpen(false)} isOpen={isOpen}>
                <ModalHeader><FormattedMessage id="Dashboard.NewDialogTitle" defaultMessage={'New Dashboard'}></FormattedMessage></ModalHeader>
                <ModalBody>
                    <FormControl
                        label={() => intl.formatMessage({ id: "Dashboard.NewDialogFormName", defaultMessage: "Name" })}
                        caption={() => intl.formatMessage({ id: "Dashboard.NewDialogFormNameDescr", defaultMessage: "Enter a name for your new Dashboard" })}
                    >
                        <Input autoFocus value={newName} onChange={onNewNameChange} placeholder={intl.formatMessage({ id: "Dashboard.NewDialogFormName", defaultMessage: "Name" })} />
                    </FormControl>
                    <FormControl
                        label={() => intl.formatMessage({ id: "Dashboard.NewDialogFormRG", defaultMessage: "Resource Group" })}
                        caption={() => intl.formatMessage({ id: "Dashboard.NewDialogFormRGDescr", defaultMessage: "Select the resource Group (only if no parent is set)" })}
                    >
                        <Select
                            multi={false}
                            options={resourceGroupsSelect}
                            value={resourceGroup}
                            onChange={onResourceGroupChanged}
                        />
                    </FormControl>
                </ModalBody>
                <ModalFooter>
                    <ModalButton kind="tertiary" onClick={() => setIsOpen(false)}>
                        <FormattedMessage id='cancel' defaultMessage='Cancel' />
                    </ModalButton>
                    <ModalButton onClick={handleNewDashboardClick} disabled={!newName || !resourceGroup} isLoading={createDashboardResult.isLoading}>
                        <FormattedMessage id='ok' defaultMessage='Ok' />
                    </ModalButton>
                </ModalFooter>
            </Modal>
        </>
    );
}

export default NewButton;